import { render, staticRenderFns } from "./ListaHistorialCostos.vue?vue&type=template&id=6fb81fa4&scoped=true&"
import script from "./ListaHistorialCostos.vue?vue&type=script&lang=js&"
export * from "./ListaHistorialCostos.vue?vue&type=script&lang=js&"
import style0 from "./ListaHistorialCostos.vue?vue&type=style&index=0&id=6fb81fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb81fa4",
  null
  
)

export default component.exports